/* eslint-disable react/prop-types */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import Flex from 'components/common/Flex';
import CurrencyDropdown from 'components/wise-components/CurrencyDropdown';
import { countryOptions } from 'components/wise-components/CurrencyInput';
import TooltipComponent from 'components/wise-components/TooltipComponent';
import { comparePriceData } from 'data/comparePriceData';
import React, { useState } from 'react';
import { Button, Form, Modal, Table } from 'react-bootstrap';

function ComparePriceModal({ handleClose, show }) {
  const [showMore, setShowMore] = useState(true);
  const [collectedData, setCollectedData] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState(countryOptions[4]);
  const [convertCurrency, setConvertCurrency] = useState(countryOptions[90]);

  let collectedDataContent;

  if (collectedData) {
    collectedDataContent = (
      <Button
        variant="link"
        onClick={() => setCollectedData(false)}
        className="bg-transparent border-0 shadow-none text-800 fs--1 fw-semi-bold d-flex align-items-center mx-auto"
      >
        <div
          style={{ height: '30px', width: '30px' }}
          className="border rounded-circle d-flex align-items-center justify-content-center me-2"
        >
          <FontAwesomeIcon icon="times" size="lg" />
        </div>
        Close
      </Button>
    );
  } else {
    collectedDataContent = (
      <p className="fs--1 text-center mb-0">
        The above information applies when you pay in via bank transfer.
        <Button
          variant="link"
          className="p-0 ms-1 fs--1"
          onClick={() => setCollectedData(true)}
        >
          How do we collect this data?
        </Button>
      </p>
    );
  }

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter" className="fs-1">
          See how we compare with other providers
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="compare-price-modal">
          <div className="p-3">
            <Flex
              justifyContent="between"
              className="mb-5 flex-column flex-md-row"
            >
              <CurrencyDropdown
                selectedCurrency={selectedCurrency}
                setSelectedCurrency={setSelectedCurrency}
              />
              <Button className="p-0 bg-transparent border-0 shadow-none text-900 mx-4 my-md-0 my-3">
                <FontAwesomeIcon icon="exchange-alt" />
              </Button>
              <CurrencyDropdown
                selectedCurrency={convertCurrency}
                setSelectedCurrency={setConvertCurrency}
              />
            </Flex>

            <Flex
              justifyContent="between"
              className="mb-4 flex-column flex-md-row"
            >
              <div className="w-100 mb-3 mb-md-0 text-center text-md-start">
                <p className="mb-0 fs-1 fw-semi-bold text-1100">
                  1 GBP = 1.14824 EUR
                  <FontAwesomeIcon
                    icon="circle"
                    size="xs"
                    className={classNames(
                      'ms-2 currency-compare-status text-success'
                    )}
                  />
                </p>
                <p className="mb-0 fs--1 text-1000">
                  Mid-market exchange rate (from Reuters){' '}
                  <span className="d-block">2 minutes ago</span>
                </p>
              </div>
              <div className="mx-4 px-2" />

              <Form className="w-100">
                <Form.Group className="position-relative">
                  <Form.Label className="fs--1 fw-normal mb-1">
                    You send exactly
                  </Form.Label>
                  <Form.Control size="lg" className="p-3 pe-8" type="number" />
                  <div className="compare-send-input">
                    <img src={selectedCurrency.image} alt="" />
                    <span className="ms-2">{selectedCurrency.value}</span>
                  </div>
                </Form.Group>
              </Form>
            </Flex>
          </div>

          <Table
            responsive
            className="overflow-hidden"
            style={{ borderRadius: '20px 20px 0 0' }}
          >
            <thead className="bg-primary rounded-4 text-100">
              <tr className="align-middle">
                <th scope="col" className="border-bottom-0">
                  Provider
                </th>
                <th scope="col" className="d-flex flex-column border-bottom-0">
                  <span>Exchange rate</span>
                  <span className="fs--1">(1 GBP → EUR)</span>
                </th>
                <th scope="col" className="border-bottom-0">
                  Transfer fee
                </th>
                <th scope="col" className="d-flex flex-column border-bottom-0">
                  <span>Recipient gets</span>
                  <span className="fs--1 text-400">Sending 1,000 GBP</span>
                </th>
              </tr>
            </thead>
            <tbody>
              {comparePriceData?.map(item => (
                <tr key={item.id}>
                  <td className="py-3 align-middle">
                    <img src={item.image} style={{ height: '30px' }} alt="" />
                  </td>
                  <td className="py-3 align-middle">
                    <p className="mb-0 fw-semi-bold fs--1">
                      {item.rate.amount}
                      <FontAwesomeIcon
                        icon="circle"
                        size="xs"
                        className={classNames('ms-2 currency-compare-status', {
                          'text-danger': item.rate.status === 'bad',
                          'text-success': item.rate.status === 'good'
                        })}
                      />
                    </p>
                    {item.rate?.type && (
                      <p className="mb-0 fs--1">
                        {item.rate?.type}{' '}
                        {item.rate.ref && (
                          <sup>
                            <a href={item.rate.ref}>
                              [
                              <FontAwesomeIcon
                                icon="question"
                                style={{ fontSize: '8px' }}
                              />
                              ]
                            </a>
                          </sup>
                        )}
                      </p>
                    )}
                  </td>
                  <td className="py-3 align-middle">
                    <p className="mb-0 fw-semi-bold fs--1">{item.fee.amount}</p>
                    {item.rate?.type && (
                      <p className="mb-0 fs--1">
                        {item.fee?.type}{' '}
                        {item.fee.ref && (
                          <sup>
                            <a href={item.rate.ref}>
                              [
                              <FontAwesomeIcon
                                icon="question"
                                style={{ fontSize: '8px' }}
                              />
                              ]
                            </a>
                          </sup>
                        )}
                      </p>
                    )}
                  </td>
                  <td className="py-3 align-middle pe-0">
                    <div className="d-flex align-items-center">
                      <div>
                        <p className="mb-0 fs-1 fw-semi-bold">
                          {item.recipientGets.amount}
                        </p>
                        <p className="mb-0 text-danger fs--1">
                          {item.recipientGets.info}
                        </p>
                      </div>
                      {item.recipientGets.warning && (
                        <TooltipComponent
                          text={item.recipientGets.warning}
                          style={{ position: 'fixed', width: '300px' }}
                          position="top"
                          btnText={
                            <Button className="bg-transparent text-danger p-0 border-0 shadow-none ms-3">
                              <FontAwesomeIcon icon="exclamation-triangle" />
                            </Button>
                          }
                        />
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

          <div className="text-center mb-5">
            <Button
              variant="link"
              onClick={() => setShowMore(pre => !pre)}
              className="bg-transparent border-0 shadow-none text-800 fs--1 fw-semi-bold d-flex align-items-center mx-auto"
            >
              <div
                style={{ height: '30px', width: '30px' }}
                className="border rounded-circle d-flex align-items-center justify-content-center me-2"
              >
                <FontAwesomeIcon
                  icon={!showMore ? 'angle-up' : 'angle-down'}
                  size="lg"
                />
              </div>
              Show {!showMore ? 'fewer' : 'more'} providers
            </Button>
          </div>

          {collectedDataContent}

          {collectedData && (
            <div className="text-center mt-4">
              <p className="mb-0">Coming..</p>
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ComparePriceModal;
